import { render, staticRenderFns } from "./V4SupplierOrdersTable.vue?vue&type=template&id=0ed83eac&"
import script from "./V4SupplierOrdersTable.vue?vue&type=script&lang=js&"
export * from "./V4SupplierOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports